import { ValidatorFn } from '@angular/forms';
import { MiqCatalog } from '../validator/required';
import { HasValidatorFn } from './has-validator-fn';

/**
 * Implements HasValidatorFn for Section objects
 * @returns
 */
export function hasSectionValidatorFn(): HasValidatorFn {
  function validatorFns() {
    const validators: ValidatorFn[] = [];
    if (this.required) {
      validators.push(MiqCatalog.required);
    }
    return validators;
  }
  return { validatorFns };
}
